import {Inject, Injectable} from '@angular/core';
import {map} from 'rxjs/internal/operators/map';
import {Router} from '@angular/router';
import {
    AuthControllerService,
    AuthenticatedUserDto,
    OtpRequestDto,
    OtpResponseDto,
    ResetPasswordRequestDto,
    ResetPasswordResponseDto
} from '../../@api';
import {Observable} from 'rxjs';
import {BrowserStorageService} from '../../service/browser.storage.service';
import {AuthenticationNotificationService} from './authentication-notification-service';
import {DOCUMENT} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationManager {

    authUserKey: string = '$au';
    authenticatedUser: AuthenticatedUserDto;

    constructor(@Inject(DOCUMENT) public document: Document,
                private router: Router,
                private authenticationService: AuthControllerService,
                private browser: BrowserStorageService,
                private authenticationNotificationService: AuthenticationNotificationService) {
        let authenticatedUser: string = this.browser.getLocalStorageValue(this.authUserKey);
        if (authenticatedUser) {
            this.authenticatedUser = JSON.parse(authenticatedUser);
        }
    }

    authenticate(model: any): Observable<boolean> {
        let authenticated: boolean = false;
        return this.authenticationService.authenticateUser(model)
            .pipe(map((response: AuthenticatedUserDto): boolean => {
                if (response) {
                    this.setAuthUser(response);
                    authenticated = true;
                    this.authenticationNotificationService.publish(authenticated);
                    return authenticated;
                } else {
                    this.setAuthUser(null);
                    this.authenticationNotificationService.publish(authenticated);
                    return authenticated;
                }
            }));
    }

    requestOtp(request: OtpRequestDto): Observable<any> {
        return this.authenticationService.requestOtp(request)
            .pipe(map((response: OtpResponseDto): OtpResponseDto => {
                return response;
            }));
    }

    resetPassword(request: ResetPasswordRequestDto): Observable<ResetPasswordResponseDto> {
        return this.authenticationService.resetPassword(request)
            .pipe(map((response: ResetPasswordResponseDto): ResetPasswordResponseDto => {
                return response;
            }));
    }

    logout(): void {
        this.browser.removeLocalStorageValue(this.authUserKey);
        this.authenticatedUser = undefined;
        this.authenticationNotificationService.publish(false);
        this.router.navigate(['home']).then((_: boolean): void => console.log('redirect to login'));
    }

    setAuthUser(authUser: AuthenticatedUserDto): void {
        this.browser.setLocalStorageValue(this.authUserKey, JSON.stringify(authUser));
        this.authenticatedUser = authUser;
    }

    isUserAuthenticated(): boolean {
        let authenticated: boolean = false;
        try {
            if (!this.authenticatedUser) {
                let authenticatedUser: string = this.browser.getLocalStorageValue(this.authUserKey);
                if (authenticatedUser) {
                    this.authenticatedUser = JSON.parse(authenticatedUser);
                }
            }
            if (this.authenticatedUser?.userDto.customerId > 0) {
                authenticated = true;
            }
            return authenticated;
        } catch (e) {}

        return false;
    }
}
